import React, { ChangeEvent, useContext, useEffect, useState } from 'react';
import { t, Trans } from '@lingui/macro';
import { DispatchContext, StateContext } from '../state/contexts';
import Job from '../jobs/types/job';
import useFilterSetup from './hooks/use-filter-setup';
import filterBy from './services/filter-by';
import './filters.scss';
import Properties from './types/properties';

const filter = (jobs: Job[], selected: string): Job[] => {
  const values = selected
    .toLowerCase()
    .split(' ')
    .filter((it) => it !== '');

  return values.length > 0
    ? jobs.filter((job) => values.every((keyword) => job.keywords.some((jobKeyword) => jobKeyword.includes(keyword))))
    : jobs;
};

const getSelected = (selected: string[]) => selected.join(' ');

const KeywordsFilter = ({ hideLabel, showColon = false, defaultLabel, className = '' }: Properties) => {
  const state = useContext(StateContext);
  const dispatch = useContext(DispatchContext);

  const { config, filters } = state;
  const { keywords } = config.config.filters;
  const { showLabels } = config.config.ui;
  const { enabled, hidden, order, label } = keywords;

  const [currentKeywords, setCurrentKeywords] = useState(filters.keywords.selected);

  useFilterSetup('keywords', filter, undefined, getSelected);

  useEffect(() => {
    setCurrentKeywords(filters.keywords.selected);
  }, [filters.keywords.selected]);

  const publish = (event: ChangeEvent<HTMLInputElement>) => {
    const selected = event.target.value;
    setCurrentKeywords(selected);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      dispatch(filterBy('keywords', currentKeywords));
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [currentKeywords]);

  return enabled && !hidden ? (
    <div className={`dvinci-job-filter ${className}`} style={{ order }}>
      {showLabels && !hideLabel && (
        <>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className="dvinci-filter-heading h4" htmlFor="keywords">
            {label || defaultLabel || <Trans>Keywords</Trans>}
            {showColon ? ':' : ''}
          </label>
        </>
      )}
      <div className="dvinci-input-wrapper">
        <input
          className="form-control"
          id="keywords"
          placeholder={!(showLabels && !hideLabel) ? label || defaultLabel || t`Keywords` : ''}
          type="text"
          value={currentKeywords}
          onChange={publish}
        />
      </div>
    </div>
  ) : (
    <></>
  );
};

export default KeywordsFilter;
